/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { Box } from '@gemini/core';
import { Button } from '@gemini/ui';
import { ArrowRightIcon } from '@gemini/icons';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from '@aviv-unified-frontend/runtime/i18n';

import AddressAutocomplete from '@/frontend/src/components/AddressAutocomplete';
import { useBreakpoint } from '@/frontend/src/hooks/useBreakpoint';
import { useAppContext } from '@/frontend/src/contexts/appContext';
import { getCtaTargetUrl } from '@/frontend/src/helpers/ctaTargetUrl';
import { NAME_SPACE } from '@/frontend/src/hooks/useLoadTranslations';

const LocationSearch = () => {
    const {
        context,
        ctaButtonInfo,
        mobileBreakpoint,
        locationResult,
        shouldDisplayHouseNumber,
        isInvalidAddress,
        tracking,
    } = useAppContext();

    const { isMobile } = useBreakpoint(mobileBreakpoint);
    const { t } = useTranslation(NAME_SPACE);
    const { handleSubmit } = useFormContext();

    const onSubmit = () => {
        if (!ctaButtonInfo.url) {
            return;
        }

        window.location.href = getCtaTargetUrl({
            context,
            ctaTargetUrl: ctaButtonInfo.url,
            locationResult,
            tracking,
        });
    };

    const gridTemplateAreasIsMobile = shouldDisplayHouseNumber
        ? '"autocomplete" "houseNumber" "message" "button"'
        : isInvalidAddress
        ? '"autocomplete" "message" "button"'
        : '"autocomplete" "button"';

    const gridTemplateAreas = shouldDisplayHouseNumber
        ? '"autocomplete houseNumber button" "message message message"'
        : isInvalidAddress
        ? '"autocomplete button" "message message"'
        : '"autocomplete button"';

    return (
        <Box
            as="form"
            testId="location-search-form"
            onSubmit={handleSubmit(onSubmit)}
            backgroundColor="color.surface.default.default"
            borderRadius="radius.16"
            display={isMobile ? 'block' : 'grid'}
            gridTemplateAreas={
                isMobile ? gridTemplateAreasIsMobile : gridTemplateAreas
            }
            gridTemplateColumns={isMobile ? '' : '1fr min-content'}
            gap="spacing.16"
        >
            <AddressAutocomplete />
            {ctaButtonInfo.url && (
                <Box
                    gridArea="button"
                    position={isMobile ? 'static' : 'relative'}
                    top={isMobile ? '0' : '28px'}
                    marginTop={isMobile ? 'spacing.16' : ''}
                >
                    <Button
                        type="submit"
                        icon={ArrowRightIcon}
                        iconPosition="end"
                        size="48"
                        isFullWidth
                    >
                        {t('common.startMyEstimationButton.label')}
                    </Button>
                </Box>
            )}
        </Box>
    );
};

export default LocationSearch;
